// import { FunctionComponent, useEffect, useState, useRef } from "react";
// import styles from "./section8.module.css";
// import VoiceBot from "../VoiceBot/VoiceBot";

// const Section8: FunctionComponent = () => {
//   const [showVoiceBot, setShowVoiceBot] = useState(false);
//   const sectionRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           setShowVoiceBot(true);
//         }
//       },
//       { threshold: 0.5 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className={styles.container}>
//       {/* Wrapper for proper alignment */}
//       <div className={styles.contentWrapper}>
//         {/* Background Image - Chakra ring */}
//         <div className={`${styles.imageWrapper} ${showVoiceBot ? styles.expand : ""}`}>
//           <img className={styles.polygonIcon} alt="" src="./assets/Frame 131.svg" />
//         </div>

//         {/* VoiceBot smoothly rising */}
//         <div className={`${styles.voiceBotContainer} ${showVoiceBot ? styles.riseUp : ""}`}>
//           <VoiceBot />
//         </div>
//       </div>

//       {/* Section reference for triggering animation */}
//       <div ref={sectionRef} className={styles.sectionTrigger}></div>
//     </div>
//   );
// };

// export default Section8;
// import { FunctionComponent, useEffect, useState, useRef } from "react";
// import styles from "./section8.module.css";
// import VoiceBot from "../VoiceBot/VoiceBot";

// const Section8: FunctionComponent = () => {
//   const [showVoiceBot, setShowVoiceBot] = useState(false);
//   const sectionRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           setShowVoiceBot(true);
//         }
//       },
//       { threshold: 0.5 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className={styles.container}>
//       {!showVoiceBot && (
//         <div className={`${styles.imageWrapper}`}>
//           <img className={styles.polygonIcon} alt="" src="./assets/Frame 131.svg" />
//         </div>
//       )}


//       {showVoiceBot && (
//         <div className={`${styles.voiceBotContainer} ${showVoiceBot ? styles.riseUp : ""}`}>
//           <VoiceBot />
//         </div>
//       )}

//       {/* Section reference for triggering animation */}
//       <div ref={sectionRef} className={styles.sectionTrigger}></div>
//     </div>
//   );
// };

// export default Section8;
import { FunctionComponent, useEffect, useState, useRef } from "react";
import styles from "./section8.module.css";
import VoiceBot from "../VoiceBot/VoiceBot";
import Vortex from "../AceternityUI/3D-cardEffect/Vortex";
import WavyBackground from "../AceternityUI/3D-cardEffect/WavyBackground";

const Section8: FunctionComponent = () => {
  const [showVoiceBot, setShowVoiceBot] = useState(false);
  const [scale, setScale] = useState(1);
  const sectionRef = useRef<HTMLDivElement>(null);

  // Scaling effect on scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = Math.min(1 + scrollY / 15000, 1.4); // Reduce max scale

      setScale(Math.min(newScale, 2)); // Max scale: 4x
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Observe section for both appearing and disappearing events
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setShowVoiceBot(true);
        } else {
          setShowVoiceBot(false); // Reset when scrolling back up
        }
      },
      { threshold: 0.1, rootMargin: "100px 0px" }

    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.container} >
      <div style={{ marginTop: "600px" }}>
        <Vortex
          className={styles.vortexBackground}
        />
      </div>
      <div
        className={`${styles.imageWrapper} ${showVoiceBot ? styles.hidden : ""}`}
        style={{ transform: `scale(${scale})`, transition: "transform 0.7s ease-out, opacity 1s ease-out" }}
      >
        <div className={`${styles.imageWrapper} ${showVoiceBot ? styles.hidden : ""}`}
          style={{ transform: `scale(${scale})`, transition: "transform 0.7s ease-out, opacity 1s ease-out" }}>

          <div className={styles.wavyBackground}>
            <WavyBackground />
          </div>

          {/* Image */}
          <img className={styles.polygonIcon} alt="" src="./assets/Frame 131 (1).svg" />
        </div>


      </div>

      <div className={`${styles.voiceBotContainer} ${showVoiceBot ? styles.riseUp : ""}`}>
        <VoiceBot />
      </div>

      {/* Section reference for triggering animation */}
      <div ref={sectionRef} className={styles.sectionTrigger}></div>
    </div>
  );
};

export default Section8;
